<!-- side-bar single product slider start -->
<div class="theme-card">
    <h5 class="title-border">{{ title }}</h5>
    <owl-carousel-o [options]="NewProductSliderConfig" class="offer-slider">
        <ng-container *ngFor="let market of markets | slice:0:3 ">

            <ng-template carouselSlide>
                <div>
                    <div class="media" *ngFor="let market of markets | slice:0:3 ">
                        <a [routerLink]="['/shop/product/left/sidebar/', market.link]" style="width: 155%;">
                            <img class="img-fluid w-auto" [defaultImage]="'assets/images/product/placeholder.jpg'" [lazyLoad]="market.img" alt="">
                        </a>
                        <div class="media-body align-self-center">
                            <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
                            <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                                <h6>{{ webLink(market.link) }}</h6>
                            </a>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template carouselSlide>
                <div>
                    <div class="media" *ngFor="let market of markets | slice:3:6 ">
                        <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                            <img class="img-fluid w-auto" [defaultImage]="'assets/images/product/placeholder.jpg'" [lazyLoad]="market.img" alt="">
                        </a>
                        <div class="media-body align-self-center">
                            <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
                            <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                                <h6>{{ webLink(market.link) }}</h6>
                            </a>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template carouselSlide>
                <div>
                    <div class="media" *ngFor="let market of markets | slice:6:9 ">
                        <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                            <img class="img-fluid w-auto" [defaultImage]="'assets/images/product/placeholder.jpg'" [lazyLoad]="market.img" alt="">
                        </a>
                        <div class="media-body align-self-center">
                            <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
                            <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                                <h6>{{ webLink(market.link) }}</h6>
                            </a>
                        </div>
                    </div>
                </div>
            </ng-template>


            <ng-template carouselSlide>
                <div>
                    <div class="media" *ngFor="let market of markets | slice:9:12 ">
                        <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                            <img class="img-fluid w-auto" [defaultImage]="'assets/images/product/placeholder.jpg'" [lazyLoad]="market.img" alt="">
                        </a>
                        <div class="media-body align-self-center">
                            <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
                            <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                                <h6>{{ webLink(market.link) }}</h6>
                            </a>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template carouselSlide>
                <div>
                    <div class="media" *ngFor="let market of markets | slice:12:15 ">
                        <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                            <img class="img-fluid w-auto" [defaultImage]="'assets/images/product/placeholder.jpg'" [lazyLoad]="market.img" alt="">
                        </a>
                        <div class="media-body align-self-center">
                            <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
                            <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                                <h6>{{ webLink(market.link) }}</h6>
                            </a>
                        </div>
                    </div>
                </div>
            </ng-template>


            <ng-template carouselSlide>
                <div>
                    <div class="media" *ngFor="let market of markets | slice:15:18 ">
                        <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                            <img class="img-fluid w-auto" [defaultImage]="'assets/images/product/placeholder.jpg'" [lazyLoad]="market.img" alt="">
                        </a>
                        <div class="media-body align-self-center">
                            <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
                            <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                                <h6>{{ webLink(market.link) }}</h6>
                            </a>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template carouselSlide>
                <div>
                    <div class="media" *ngFor="let market of markets | slice:18:20 ">
                        <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                            <img class="img-fluid w-auto" [defaultImage]="'assets/images/product/placeholder.jpg'" [lazyLoad]="market.img" alt="">
                        </a>
                        <div class="media-body align-self-center">
                            <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
                            <a [routerLink]="['/shop/product/left/sidebar/', market.link]">
                                <h6>{{ webLink(market.link) }}</h6>
                            </a>
                        </div>
                    </div>
                </div>
            </ng-template>


        </ng-container>
    </owl-carousel-o>
</div>
<!-- side-bar single product slider end -->